module.exports = __webpack_public_path__ + "media/touch-button.4e08fdd6.wav";